import React, { useEffect } from "react";
import { useState } from "react";
import {
    Box, Card, CardContent, Typography, Avatar, Grid, Button, Link, Divider, Tabs, Tab, Chip, IconButton,
} from "@mui/material";
import CropSquareIcon from "@mui/icons-material/CropSquare";          // BUA
import LandscapeIcon from "@mui/icons-material/Landscape";           // Land
import DonutLargeIcon from "@mui/icons-material/DonutLarge";         // Leasing
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet"; // Budget

import { ReactComponent as FilterListIcon } from "assets/icons/View list.svg";
import { ReactComponent as MoreVertIcon } from "assets/icons/MoreVertIcon.svg";
import { ReactComponent as VectorRight } from "assets/icons/Vector.svg"
import { ReactComponent as LocationIcon } from "assets/icons/Location.svg"
import { ReactComponent as DeleteOutlineIcon } from "assets/icons/DeleteOutlined.svg"
import { ReactComponent as EditIcon } from "assets/icons/EditIcon.svg"
import AllProject from "./TabsList/AllProject";
import AddedProjects from "./TabsList/AddedProject";
import CompletedProjects from "./TabsList/CompletedProject";
import { useNavigate } from "react-router-dom";
import EditProject from "../EditProject";
import DeletePopup from "../DeletePopup";
import { useDeleteProjectMutation, useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import ProjectIcon2 from "assets/icons/ProjectIcon2.svg"
import ProjectIcon4 from "assets/icons/ProjectIcon4.svg"
import AeroplaneIcon from "assets/icons/ProjectIcon1.svg"
import HeartIcon from "assets/icons/HeartIcon.svg"
import ProjectIcon3 from "assets/icons/ProjectIcon3.svg"
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useDispatch } from "store";
import { useLazyGetProjectPermissionQuery } from "store/slices/apis/projectPermissionSlice";
import { useAuth } from "context/AuthContext";
import EnterprisePageShell from "components/EnterprisePageShell";
import { enterpriseTokens } from "styles/theme";

const ProjectList = () => {
    const projectType = localStorage.getItem("projectType") || "FOURWRD";
    const [value, setValue] = useState(0);
    const [loading, setLoading] = useState(false)
    const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
    const [selectedProjectData, setSelectedProjectData] = useState(null);
    const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);
    const { data, error, isLoading, isFetching, refetch } = useGetAllProjectsQuery(projectType);
    const [deleteProject,] = useDeleteProjectMutation();
    const [projectPermissionFun, projectPermissionRes] = useLazyGetProjectPermissionQuery();
    const { setUser, user } = useAuth();
    const isCustomer = user?.roles?.includes("Customer");
    const [deleteDataId, setDeleteDataId] = useState(null)

    const dispatch = useDispatch();

    const iconList = [
        { name: "ProjectIcon2", src: ProjectIcon2 },
        { name: "ProjectIcon4", src: ProjectIcon4 },
        { name: "AeroplaneIcon", src: AeroplaneIcon },
        { name: "HeartIcon", src: HeartIcon },
        { name: "ProjectIcon3", src: ProjectIcon3 },
    ];

    const projectData = data?.data || [];

    const navigate = useNavigate();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const handleEditClick = (project) => {
        setSelectedProjectData(project);
        setIsEditPopupOpen(true);
    }


    const handleClosePopup = () => {
        setIsEditPopupOpen(false);
        setSelectedProjectData(null);
        refetch();
    }

    const handleDeleteClosePopup = () => {
        setDeletePopupOpen(false)
    }

    const openNotification = (msg, type = "error", duration = 6000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type, variant: "filled" },
                transition: "SlideUp",
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleDeleteClick = async (data) => {
        setDeleteDataId(data)
        setDeletePopupOpen(true)

    }

    const handleCreateProject = () => {
        navigate("/addproject")
    }

    const handleCardClick = async (projectVal) => {
        await projectPermissionFun(projectVal?.projectId)
        // navigate(`/projects/${id}`)
    };
   
    useEffect(() => {
        if (projectPermissionRes?.isSuccess) {
            // console.log(projectPermissionRes?.data);

            if (projectPermissionRes?.data?.status?.toLowerCase() == 'success') {
                // console.log(projectPermissionRes?.data?.data?.modules);                
                setUser({
                    ...user,
                    permission: projectPermissionRes?.data?.data?.modules
                });
                // handleClick(projectPermissionRes?.originalArgs?.projectId, projectPermissionRes?.data?.result?.modules);
            }
            //navigate(`/projects/${projectPermissionRes?.originalArgs}`);
            if (user?.roles.includes("Customer")) {
                navigate(`/projects/${projectPermissionRes?.originalArgs}/dashboard/customer`);
            } else {
                navigate(`/projects/${projectPermissionRes?.originalArgs}`);
            }
        }
    }, [projectPermissionRes?.isSuccess])

    useEffect(() => {
        if (projectPermissionRes?.isError) {
            if (projectPermissionRes?.error?.data?.status) {
                // openNotification(projectPermissionRes?.error?.data?.message, "error");
            } else {
                // openNotification('We couldn’t complete the action. Please retry.', "error");
            }

            if (user?.roles.includes("Customer")) {
                navigate(`/projects/${projectPermissionRes?.originalArgs}/dashboard/customer`);
            } else {
                navigate(`/projects/${projectPermissionRes?.originalArgs}`);
            }
        }
    }, [projectPermissionRes?.isError, user])

    const onGoingDataLength = projectData.filter((data) => data.status == 'ONGOING' && data.active == true)
    const completedDataLength = projectData.filter((data) => data.status == 'COMPLETED' && data.active == true)


    if (isLoading || isFetching) {
        return <p className="text-center text-gray-500">Loading projects...</p>;
    }

    if (error) {
        return <p className="text-red-500">Failed to load projects.</p>;
    }

    return (
        <EnterprisePageShell
            eyebrow="Project Portfolio"
            title="Project operations workspace"
            description="Review active delivery sites, open project workspaces, and manage portfolio-level execution."
            actions={!isCustomer && (
                <Button
                    variant="contained"
                    onClick={handleCreateProject}
                    sx={{
                        px: 2.4,
                        height: 42,
                        borderRadius: "3px",
                        fontWeight: 800,
                        backgroundColor: enterpriseTokens.primary,
                        "&:hover": {
                            backgroundColor: enterpriseTokens.primaryDark,
                        },
                    }}
                >
                    Create Project
                </Button>
            )}
            meta={
                <>
                    {[
                        ["Total", projectData.filter((data) => data.active == true && data?.projectName != "Business").length],
                        ["Ongoing", onGoingDataLength.filter((projects) => projects?.projectName != "Business").length],
                        ["Completed", completedDataLength.length],
                    ].map(([label, value]) => (
                        <Box key={label} sx={{ px: 1.5, py: 0.9, borderRadius: "3px", background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.14)", minWidth: 112 }}>
                            <Typography sx={{ color: "#CBD5E1", fontSize: 11, fontWeight: 800, textTransform: "uppercase" }}>{label}</Typography>
                            <Typography sx={{ color: "#FFFFFF", fontSize: 20, fontWeight: 850 }}>{value}</Typography>
                        </Box>
                    ))}
                </>
            }
        >
        <Grid container spacing={2}>
            <Box sx={{
                backgroundColor: "#FFFFFF",
                p: 2,
                overflow: "hidden",
                width: "100%",
                border: `1px solid ${enterpriseTokens.lineSoft}`,
                borderRadius: "3px",
                boxShadow: "0 12px 34px rgba(15, 23, 42, 0.07)",
            }}>
                <Typography sx={{
                    color: enterpriseTokens.navy,
                    fontSize: "18px",
                    fontWeight: 850,
                    lineHeight: "24px",
                    letterSpacing: "0px",
                    fontFamily: "Inter, Outfit, sans-serif"
                }}>
                    Active project board
                </Typography>
                <Typography sx={{ color: enterpriseTokens.muted, fontSize: 13, mt: 0.4 }}>
                    Fast access to live project workspaces and current delivery indicators.
                </Typography>
                <Box
                    sx={{
                        display: "flex",
                        overflowX: "auto",
                        maxWidth: "100%",
                        gap: 2,
                        mt: "18px",
                        scrollbarWidth: "thin",
                        "&::-webkit-scrollbar": {
                            height: 8,
                        },
                        "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#aaa",
                            borderRadius: 4,
                        },
                    }}
                >
                    {onGoingDataLength.filter((projects) => projects?.projectName != 'Business')?.map((card, index) => (
                        <Card
                            key={card.id}
                            onClick={() => handleCardClick(card)}
                            sx={{
                                minWidth: "292px",
                                minHeight: "222px",
                                border: `1px solid ${enterpriseTokens.lineSoft}`,
                                borderRadius: "3px",
                                display: "flex",
                                flexDirection: "column",
                                flexShrink: 0,
                                overflow: "hidden",
                                cursor: "pointer",
                                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
                                transition: "transform 160ms ease, box-shadow 160ms ease",
                                "&:hover": {
                                    transform: "translateY(-3px)",
                                    boxShadow: "0 16px 36px rgba(15, 23, 42, 0.12)",
                                },
                            }}
                        >

                            <Box
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    padding: "12px 14px",
                                    gap: "11px",
                                    backgroundColor: index % 2 === 0 ? "#EFF6FF" : "#ECFEFF",
                                    borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
                                }}
                            >
                                <Avatar sx={{ width: 34, height: 34, bgcolor: "#FFFFFF", border: `1px solid ${enterpriseTokens.lineSoft}` }}>
                                    {(() => {
                                        const icon = iconList.find((i) => i.name === card.projectIcon);
                                        return icon ? (
                                            <img
                                                src={icon.src}
                                                alt={icon.name}
                                                width="30"
                                                height="30"
                                            />
                                        ) : null;
                                    })()}
                                </Avatar>
                                <Box sx={{
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "flex-start"
                                }}>
                                    <Box>
                                        <Typography
                                            variant="h6"
                                            sx={{ fontSize: "17px", fontWeight: 850, color: enterpriseTokens.navy, fontFamily: "Inter, Outfit, sans-serif" }}
                                        >
                                            {card.projectName}
                                        </Typography>
                                        <Typography sx={{ fontSize: "13px", fontWeight: 600, color: enterpriseTokens.muted, fontFamily: "Inter, Outfit, sans-serif" }} >
                                            {card.city}, {card.country}
                                        </Typography>
                                    </Box>

                                </Box>
                            </Box>


                            <Box
                                sx={{
                                    pt: "12px",
                                    px: "16px",
                                    backgroundColor: "transparent",
                                }}
                            >
                                {/* 2x2 metrics grid */}
                                <Box
                                    sx={{
                                        display: "grid",
                                        gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                                        columnGap: 2,
                                        rowGap: 1.5,
                                    }}
                                >
                                    {/* Total Land */}
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                            <LandscapeIcon sx={{ fontSize: 14, color: "#696484" }} />
                                            <Typography
                                                sx={{
                                                    fontSize: "10px",
                                                    fontWeight: 500,
                                                    textTransform: "uppercase",
                                                color: enterpriseTokens.muted,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                                }}
                                            >
                                                Total Land
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                color: enterpriseTokens.navy,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                            }}
                                        >
                                            {card.totalLand} M sq.ft
                                        </Typography>
                                    </Box>
                                    {/* BUA */}
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                            <CropSquareIcon sx={{ fontSize: 14, color: "#696484" }} />
                                            <Typography
                                                sx={{
                                                    fontSize: "10px",
                                                    fontWeight: 500,
                                                    textTransform: "uppercase",
                                                color: enterpriseTokens.muted,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                                }}
                                            >
                                                BUA
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                color: enterpriseTokens.navy,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                            }}
                                        >
                                            {card.builtUpArea} M sq.ft
                                        </Typography>
                                    </Box>

                                    {/* Leasing % */}
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                            <DonutLargeIcon sx={{ fontSize: 14, color: "#696484" }} />
                                            <Typography
                                                sx={{
                                                    fontSize: "10px",
                                                    fontWeight: 500,
                                                    textTransform: "uppercase",
                                                color: enterpriseTokens.muted,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                                }}
                                            >
                                                Leasing
                                            </Typography>
                                        </Box>
                                        <Typography
                                            sx={{
                                                fontSize: "13px",
                                                fontWeight: 500,
                                                color: enterpriseTokens.navy,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                            }}
                                        >
                                            {card.leasingPercentage} %
                                        </Typography>
                                    </Box>

                                    {/* Budget */}
                                    {!isCustomer && (
                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 0.3 }}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 0.8 }}>
                                                <AccountBalanceWalletIcon sx={{ fontSize: 14, color: "#696484" }} />
                                                <Typography
                                                    sx={{
                                                        fontSize: "10px",
                                                        fontWeight: 500,
                                                        textTransform: "uppercase",
                                                        color: enterpriseTokens.muted,
                                                        fontFamily: "Inter, Outfit, sans-serif",
                                                    }}
                                                >
                                                    Budget
                                                </Typography>
                                            </Box>
                                            <Typography
                                                sx={{
                                                    fontSize: "13px",
                                                    fontWeight: 500,
                                                color: enterpriseTokens.navy,
                                                fontFamily: "Inter, Outfit, sans-serif",
                                                }}
                                            >
                                                Rs {card.budgetedCost} Cr
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>

                                {/* Progress */}
                                <Typography
                                    sx={{
                                        mt: 1.8,
                                        fontSize: "12px",
                                        fontWeight: 400,
                                        color: enterpriseTokens.slate,
                                        fontFamily: "Inter, Outfit, sans-serif",
                                    }}
                                >
                                    Construction Progress: {card.actualProgress} %
                                </Typography>
                            </Box>


                            <Box sx={{ pl: "33px", pb: "20px" }}>
                                <Box sx={{ mt: "16px" }}>
                                    <Divider sx={{ borderColor: enterpriseTokens.lineSoft }} />
                                </Box>
                                <Box sx={{
                                    paddingLeft: "22px",
                                    mt: "11px",

                                }}>
                                    <Button sx={{ textTransform: "none", display: "flex", alignItems: "center", gap: "4px", p: 0 }}>
                                        <Typography sx={{
                                            fontSize: "12px",
                                            fontWeight: 400,
                                            lineHeight: "100%",
                                            color: enterpriseTokens.primary,
                                            textDecoration: "none",
                                            fontFamily: "Inter, Outfit, sans-serif",
                                            fontWeight: 800,
                                        }}>
                                            More details
                                        </Typography>
                                        <Avatar sx={{ width: "10px", height: "10px", bgcolor: "#FFFFFF" }}>
                                            <VectorRight style={{ width: "10px", height: "10px", fill: "#433F5E" }} />
                                        </Avatar>
                                    </Button>


                                </Box>


                            </Box>

                        </Card>

                    ))}
                </Box>

            </Box>
            <Grid size={12} sx={{ backgroundColor: "#FFFFFF", border: `1px solid ${enterpriseTokens.lineSoft}`, borderRadius: "3px", boxShadow: "0 12px 34px rgba(15, 23, 42, 0.07)", overflow: "hidden" }}>
                <Box
                    sx={{
                        width: "100%",
                        borderBottom: `1px solid ${enterpriseTokens.lineSoft}`,
                        overflowX: "auto",
                        whiteSpace: "nowrap",
                        p: 1.5,
                        "-webkit-overflow-scrolling": "touch",
                    }}
                >
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        TabIndicatorProps={{ style: { display: "none" } }}
                        variant="scrollable"
                        scrollButtons={false}
                        sx={{
                            justifyContent: "flex-start !important",
                            alignItems: "flex-start",
                            "& .MuiTabs-flexContainer": {
                                justifyContent: "flex-start !important",
                                gap: "8px",
                            },
                        }}
                    >
                        {["All Projects", "Recently Added", "Completed"].map((label, index) => (
                            <Tab
                                key={index}
                                label={
                                    <Box
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "6px",
                                        }}
                                    >
                                        <Typography
                                            sx={{
                                                fontWeight: 800,
                                                fontSize: "14px",
                                                lineHeight: "18px",
                                                color: value === index ? "#FFFFFF" : enterpriseTokens.slate,
                                                fontFamily: "Inter, Outfit, sans-serif"
                                            }}
                                        >
                                            {label}
                                        </Typography>


                                        {(index === 1 || index === 2) && (
                                            <Chip
                                                label={
                                                    index === 1
                                                        ? onGoingDataLength.length || ""
                                                        : index === 2
                                                            ? completedDataLength.length || ""
                                                            : ""
                                                }
                                                sx={{
                                                    height: "20px",
                                                    width: "32",
                                                    fontSize: "14px",
                                                    fontWeight: 500,
                                                    lineHeight: 1,
                                                    backgroundColor: value === index ? "rgba(255,255,255,0.18)" : enterpriseTokens.surfaceAlt,
                                                    color: value === index ? "#FFFFFF" : enterpriseTokens.slate,
                                                }}
                                            />
                                        )}
                                    </Box>
                                }
                                sx={{
                                    textTransform: "none",
                                    minWidth: "auto",
                                    minHeight: "38px",
                                    px: 1.6,
                                    py: 1,
                                    borderRadius: "3px",
                                    backgroundColor: value === index ? enterpriseTokens.primary : "transparent",
                                    border: `1px solid ${value === index ? enterpriseTokens.primary : "transparent"}`,
                                }}
                            />
                        ))}
                    </Tabs>
                </Box>
                {
                    value === 0 && <AllProject data={projectData.filter((data) => data.active == true && data?.projectName != 'Business')} handleChange={handleChange} handleEditClick={handleEditClick} handleDeleteClick={handleDeleteClick} customerChk={isCustomer} />
                }
                {
                    value === 1 && <AddedProjects data={projectData.filter((data) => data.status == "ONGOING" && data.active == true && data?.projectName != 'Business')} handleChange={handleChange} handleEditClick={handleEditClick} handleDeleteClick={handleDeleteClick} customerChk={isCustomer} />
                }
                {
                    value === 2 && <CompletedProjects data={projectData.filter((data) => data.status == "COMPLETED" && data.active == true && data?.projectName != 'Business')} handleChange={handleChange} handleEditClick={handleEditClick} handleDeleteClick={handleDeleteClick} customerChk={isCustomer} />
                }

            </Grid>

            {!isCustomer && (
                <>
                    {/*  Edit Project Popup */}
                    < EditProject
                        open={isEditPopupOpen}
                        onClose={handleClosePopup}
                        projectData={selectedProjectData}
                        setIsEditPopupOpen={setIsEditPopupOpen}
                    />

                    <DeletePopup
                        open={isDeletePopupOpen}
                        onClose={handleDeleteClosePopup}
                        data={deleteDataId}
                    />
                </>
            )}




        </Grid >
        </EnterprisePageShell>
    );
};

export default ProjectList;
